"use strict";
/*
 * Created on 20.03.2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * @author ZSr
 */


var PromotionSplitDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(PromotionSplitDTOConverter, _DataObjectConverter_);

  function PromotionSplitDTOConverter() {
    _classCallCheck(this, PromotionSplitDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(PromotionSplitDTOConverter).apply(this, arguments));
  }

  return PromotionSplitDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.PromotionSplitDTOConverter = PromotionSplitDTOConverter;